import { RESET_PASSWORD_FAILURE, RESET_PASSWORD_SUCCESS, RESET_PASSWORD } from './actionTypes';
import { resetPasswordAPI } from '../api/resetPasswordAPI';

export function resetPasswordSuccess(data) {
    return { data, type: RESET_PASSWORD_SUCCESS };
}

export function resetPassword(userId, timestamp, signature, password) {
    return (dispatch) => {
        dispatch({ type: RESET_PASSWORD });
        return resetPasswordAPI(userId, timestamp, signature, password)
            .then(() => dispatch(resetPasswordSuccess(true)))
            .catch(({ response }) => dispatch({ response, type: RESET_PASSWORD_FAILURE }));
    };
}
